// extracted by mini-css-extract-plugin
export default {"wrapper":"ingredient_wrapper__iRc46","container":"ingredient_container__7pez3"};